import {DocumentData} from "@angular/fire/compat/firestore";
import {getDownloadURL, ref, Storage} from "@angular/fire/storage";
import {inject} from "@angular/core";
import * as url from "url";
import {LanguageService} from "./language.service";
import {CropperPosition} from "ngx-image-cropper";

export class Tour implements TourModel {
  getTitle(): string {
    return this.title[Tour.languageService.currentLang$.value];
  }

  getDescription(): string {
    return this.description[Tour.languageService.currentLang$.value];
  }

  id: string = '';
  title: string[] = [];
  description: string[] = []
  step: number = 0;

  audioStorageFolder?: string;
  hasImage?: boolean = false;

  audioUrl?: string;
  imageUrl?: string = null;

  rawImageUrl?: string = null;
  cropperData: CropperPosition = null;


  static storage: Storage;
  static languageService: LanguageService;
  static async fromJSON(json: TourModel | DocumentData): Promise<Tour> {
    let tour = new Tour();
    tour.id = json.id;
    tour.title = json.title;
    tour.description = json.description;
    tour.step = json.step;

    if (json.audioStorageFolder) {
      tour.audioStorageFolder = json.audioStorageFolder;

      const filePath = "soundfiles/" + `${tour.audioStorageFolder}/${tour.audioStorageFolder}.${Tour.languageService.currentLang$.value}.mp3`;

      // const docRef = ref(Tour.storage, filePath);
      // tour.audioUrl = await getDownloadURL(docRef).catch(() => null);
      tour.audioUrl = "https://storage.googleapis.com/audiotour-2e51a.appspot.com/" + filePath;
    }

    // if (json.audioUrl) {
    //   tour.audioUrl = json.audioUrl;
    // }

    if (json.hasImage) {
      tour.hasImage = json.hasImage;
      const filePath = "tour-images/cropped/optimized-" + `${tour.id}.jpg`;
      const rawFilePath = "tour-images/raw/" + `${tour.id}.jpg`;

      // const docRef = ref(Tour.storage, filePath);
      // // tour.imageUrl = await getDownloadURL(docRef).catch(() => null);
      //
      // getDownloadURL(docRef).then((url) => {
      //   tour.imageUrl = url;
      // }).catch((err) => {
      //   tour.imageUrl = null;
      //   console.log('Error loading image', err);
      // });

      tour.imageUrl = "https://storage.googleapis.com/audiotour-2e51a.appspot.com/" + filePath;
      tour.rawImageUrl = "https://storage.googleapis.com/audiotour-2e51a.appspot.com/" + rawFilePath;
      tour.cropperData = json.cropperData;
    }
    return tour;
  }

  toJSON(): TourModel {
    const model = {
      id: this.id,
      title: this.title,
      description: this.description,
      step: this.step
    }

    model['hasImage'] = this.hasImage ?? false;
    if (this.hasImage) {
      model['cropperData'] = this.cropperData;
    }

    if (this.audioStorageFolder) {
      model['audioStorageFolder'] = this.audioStorageFolder;
    }
    // if (this.audioUrl) {
    //   model['audioUrl'] = this.audioUrl;
    // }

    return model;
  }

}

export interface TourModel {
  id?: string;
  title: string[];
  description?: string[];
  step: number;

  audioStorageFolder?: string;
  hasImage?: boolean;
  cropperData?: any;

  audioUrl?: string;
  imageUrl?: string;
}
